import {
  LegalClientSourcesOfIncomeFinancialSourceType,
  LegalClientSourcesOfIncomeSourceType,
} from 'api/types/entity';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import { DocumentsTableFeature } from 'modules/client/common/feature';

import { useFormContext, Field } from '../../../../forms/sourcesOfIncomeForm';

export interface FormContentProps {}

export const FormContent = () => {
  const { values } = useFormContext();
  const { t } = useTranslation();

  const isOtherIncomeSource =
    values.sourcesOfIncome?.incomeSources?.find(
      (v) => v?.value === LegalClientSourcesOfIncomeSourceType.Other
    ) !== undefined;

  const isOtherFinancialSource =
    values.sourcesOfIncome?.financialSources?.find(
      (v) => v?.value === LegalClientSourcesOfIncomeFinancialSourceType.Other
    ) !== undefined;

  return (
    <Stack spacing={24}>
      <GridFields>
        <Field.Autocomplete
          multiple
          showRequiredMark
          label={t('client.legal.sourcesOfIncome.incomeSources.label')}
          name="sourcesOfIncome.incomeSources"
          optionLabelKey="label"
          options={Object.values(LegalClientSourcesOfIncomeSourceType).map(
            (v) => ({
              label: t(`client.legal.sourcesOfIncome.incomeSources.types.${v}`),
              value: v,
            })
          )}
          optionValueKey="value"
          placeholder={t(
            'client.legal.sourcesOfIncome.incomeSources.placeholder'
          )}
          variant="select"
        />

        {isOtherIncomeSource && (
          <Field.Text
            showRequiredMark
            label={t('client.legal.sourcesOfIncome.otherIncomeSource.label')}
            name="sourcesOfIncome.otherIncomeSource"
            placeholder={t(
              'client.legal.sourcesOfIncome.otherIncomeSource.placeholder'
            )}
          />
        )}

        <Field.Autocomplete
          multiple
          showRequiredMark
          label={t('client.legal.sourcesOfIncome.financialSources.label')}
          name="sourcesOfIncome.financialSources"
          optionLabelKey="label"
          options={Object.values(
            LegalClientSourcesOfIncomeFinancialSourceType
          ).map((v) => ({
            label: t(
              `client.legal.sourcesOfIncome.financialSources.types.${v}`
            ),
            value: v,
          }))}
          optionValueKey="value"
          placeholder={t(
            'client.legal.sourcesOfIncome.financialSources.placeholder'
          )}
          variant="select"
        />

        {isOtherFinancialSource && (
          <Field.Text
            showRequiredMark
            label={t('client.legal.sourcesOfIncome.otherFinancialSource.label')}
            name="sourcesOfIncome.otherFinancialSource"
            placeholder={t(
              'client.legal.sourcesOfIncome.otherFinancialSource.placeholder'
            )}
          />
        )}
      </GridFields>
      <DocumentsTableFeature name="sourcesOfIncome.files" />
    </Stack>
  );
};
